/**
 * @file shop-features.ts
 * @description Что работает у магазина для условных заготовок и элементов
 * секции (phase19.16 Р2; SB26 — «Подписка» только при работающей рассылке).
 *
 * Модуля рассылок в платформе пока нет: сервер всегда отвечает «нет»
 * (apps/api site-pages/newsletter-availability.ts) и отклоняет заготовку
 * 409 `preset_unavailable`. Отдельного признака в API для кабинета нет —
 * когда рассылка появится, признак придёт с сервера (нужен эндпоинт или
 * поле в ответе страницы) и заменит эту константу.
 */

import type { PresetFeatures } from "./preset-library";

export const SHOP_FEATURES: PresetFeatures = { newsletter: false };
